import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import { AuthProvider, useAuth } from 'contexts/AuthContext';
import { setupAxiosInterceptors } from 'api/axiosInterceptor';

// ==============================|| APP INIT COMPONENT ||============================== //

function AppInit() {
  const { token, logout } = useAuth();

  // Initialize axios interceptors on app load
  useEffect(() => {
    setupAxiosInterceptors(() => token, logout);
  }, [token, logout]);

  return (
    <ThemeCustomization>
      <ScrollTop>
        <RouterProvider router={router} />
      </ScrollTop>
    </ThemeCustomization>
  );
}

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <AuthProvider>
      <AppInit />
    </AuthProvider>
  );
}
